// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });

    gsap.registerPlugin(ScrollTrigger);

    const counter = document.querySelectorAll('.count');
    if (counter) {
      counter.forEach(el => {
        const end = parseFloat(el.dataset.end) || 0;
        const proxy = { val: 0 };

        gsap.to(proxy, {
          val: end,
          duration: 2,
          ease: "power2.out",
          onUpdate: () => {
            el.textContent = Math.round(proxy.val).toLocaleString('pt-BR');
          },
          scrollTrigger: {
            trigger: el,
            start: "top 90%",   // quando o elemento chegar a 80% da viewport
            /*toggleActions: "play none none none", */
            toggleActions: "play none none reverse",
            //once: true          // roda só uma vez
          }
        });
      });     
    }


    const typingEl = document.querySelectorAll(".-typing");
    if (typingEl.length > 0) {
      gsap.utils.toArray(".-typing").forEach((text) => {
        //let text = document.querySelector(".-typing");
        let content = text.textContent;
        text.textContent = ""; // clear first
        gsap.to(text, {
          duration: 2.5,
          text: content,  // Requires TextPlugin
          ease: "none"
        });
      });
    }
    // Fade-in sections on scroll
    gsap.utils.toArray(".-fade-in").forEach((secfade) => {
      gsap.from(secfade, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: secfade,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });
    });

    gsap.utils.toArray(".-animate-in").forEach((sec) => {
      /*gsap.to(sec, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "none",
        //ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });*/
      gsap.from(sec, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none "
        }
      });
    });

    const slides = document.querySelectorAll('.-hg-main-slide');
    const bulletsContainer = document.querySelector('.-hg-main-navigation-bullets');
    let currentIndex = 0;
    const slideInterval = 5000; // 5 seconds per slide
    let autoSlideTimer;

    function updateCarousel(nextIndex) {
      // 1. Remove active classes from current slide and bullet
      slides[currentIndex].classList.remove('active');
      const bullets = bulletsContainer.querySelectorAll('.bullet');
      if (bullets.length) bullets[currentIndex].classList.remove('active');

      // 2. Update the index
      currentIndex = nextIndex;

      // 3. Add active classes to the new slide and bullet
      slides[currentIndex].classList.add('active');
      if (bullets.length) bullets[currentIndex].classList.add('active');
    }

    // Function triggered by the interval timer
    function nextSlide() {
      const nextIndex = (currentIndex + 1) % slides.length;
      updateCarousel(nextIndex);
    }

    // Function to start/reset the timer (prevents glitching if a user clicks right before a tick)
    function startTimer() {
      clearInterval(autoSlideTimer);
      autoSlideTimer = setInterval(nextSlide, slideInterval);
    }

    // Initialization
    if (slides.length) {
      // Dynamically generate bullets
      slides.forEach((_, index) => {
      const bullet = document.createElement('button');
      bullet.classList.add('bullet');
      if (index === 0) bullet.classList.add('active'); // First bullet is active

      // Add click event to jump to specific slide
      bullet.addEventListener('click', () => {
        updateCarousel(index);
        startTimer(); // Reset timer so it stays on the clicked slide for a full 5s
      });

      bulletsContainer.appendChild(bullet);
      });

      // Start the auto-timer
      startTimer();
    }

    /*read more*/
    var readMoreTrigger = document.getElementsByClassName("-rm-trigger");
    
    var toggleMoreContent = function() {
        var excerpt = this.parentNode.getElementsByClassName('-rm-excerpt')[0];
        var moreText = this.parentNode.getElementsByClassName('-rm-more')[0];

        if (excerpt.style.display === "none") {
          excerpt.style.display = "block";
          moreText.style.display = "none";
          this.innerHTML = "Ver mais";
        } else {
          excerpt.style.display = "none";
          moreText.style.display = "block";
          this.innerHTML = "Ver menos";
        }
    };

    for (var i = 0; i < readMoreTrigger.length; i++) {
        readMoreTrigger[i].addEventListener('click', toggleMoreContent, false);
    }     
    
    //Menu trigger
    var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
        menu = document.getElementById("main-nav");
    
    var toggleMenu = function() {
    	   //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("menu-active");
    };

    for (var i = 0; i < menuTrigger.length; i++) {
        menuTrigger[i].addEventListener('click', toggleMenu, false);
    }

    //Search trigger
    var searchTrigger = document.getElementsByClassName("search-trigger-btn");
    
    var toggleSearch = function() {
         //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("search-active");
    };

    for (var i = 0; i < searchTrigger.length; i++) {
        searchTrigger[i].addEventListener('click', toggleSearch, false);
    }

    //modal trigger
    var modalTrigger = document.getElementsByClassName("modal-trigger-btn");
    
    var toggleModal = function() {
        event.preventDefault();
        const modal = this.dataset.modal;
        if (modal) {
          document.getElementById(modal).classList.add('-modal-active');
        }
         //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("modal-active");
    };

    for (var i = 0; i < modalTrigger.length; i++) {
        modalTrigger[i].addEventListener('click', toggleModal, false);
    }

    //modal close
    var modalClose = document.getElementsByClassName("modal-close-btn");
    
    var closeModal = function() {
        event.preventDefault();
        const modals = document.querySelectorAll('.-modal');
        modals.forEach(element => {
          element.classList.remove('-modal-active');
        });
        const formModals = document.querySelectorAll('.-modal-form');
        formModals.forEach(element => {
          element.classList.remove('-active');
        });
        document.body.classList.remove("modal-active");
    };

    for (var i = 0; i < modalClose.length; i++) {
        modalClose[i].addEventListener('click', closeModal, false);
    }     
    
    

    function redirect(goto){
        /*var conf = confirm("Are you sure you want to go elswhere?");
        if (conf && goto != '') {
            window.location = goto;
        }*/
        window.location = goto;
    }
   
    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      e.preventDefault();
      const header = document.querySelector("header").offsetHeight;
      const href = this.getAttribute("href"); 
      const offsetTop = document.querySelector(href).offsetTop;
     
      scroll({
        top: offsetTop-header,
        /*top: offsetTop,*/
        behavior: "smooth"
      });
    }

    /*Anchor scroll nav*/
    const anchorsNav = document.querySelectorAll(".scroller > a");
     
    for (const anchorNav of anchorsNav) {
      anchorNav.addEventListener("click", clickHandlerNav);
    }
     
    function clickHandlerNav(e) {
      e.preventDefault();
      let header = document.querySelector("header").offsetHeight;
      let href = this.getAttribute("href"); 
      let split = href.split('#');
      let anchor = '#'+split[1];
      let offsetTop = document.querySelector(anchor).offsetTop;
      if (document.querySelector("header").classList.contains('-sticky')) {
        
      }else{
        header = header-20;
      }
      
      document.body.classList.remove("menu-active");
      
     
      scroll({
        top: offsetTop-header,
        /*top: offsetTop,*/
        behavior: "smooth"
      });
    } 


    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            if (parent) {
              parent.find('.-accordion-item').removeClass('-active');
            }
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            if (parent) {
              parent.find('.-accordion-item').removeClass('-active');
            }
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });         
      

    /*Dropdown mobile*/
    $('.dropdown-toggle-hover').click(function(){
      
      if ($(window).width() < 1025) {
        event.preventDefault();
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }else{
        return;
      }
    });

    /*quick search and toggle filter*/
    const searchInput = document.getElementById('quick-search');
    const filterContainer = document.getElementById('filters-container');
    const groups = document.querySelectorAll('.qs-search-group');
    const notFoundDiv = document.getElementById('qs-not-found');
    const clearSearchBtn = document.getElementById('clear-qs-btn');
    const filterButtons = document.querySelectorAll('.filter-btn');

    function performSearch() {
        const filter = searchInput.value.toLowerCase();
        let totalVisibleItems = 0;

        // 1. If searching, hide the category filter buttons
        if (filter.length > 0) {
            filterContainer.style.display = 'none';
        } else {
            filterContainer.style.display = 'flex'; // Or 'block' depending on CSS
            // Reset to "Show All" state visually when search is cleared
            resetCategories(); 
        }

        groups.forEach(group => {
            const items = group.querySelectorAll('li');
            let hasVisibleItems = false;

            items.forEach(item => {
                const text = item.textContent || item.innerText;
                if (text.toLowerCase().indexOf(filter) > -1) {
                    item.style.display = ""; 
                    hasVisibleItems = true;
                    totalVisibleItems++;
                } else {
                    item.style.display = "none";
                }
            });

            // Show/Hide category section based on matches
            group.style.display = hasVisibleItems ? "" : "none";
        });

        // 2. Show/Hide "Not Found" message
        if (totalVisibleItems === 0 && filter.length > 0) {
            notFoundDiv.style.display = "block";
        } else {
            notFoundDiv.style.display = "none";
        }
    }

    function resetCategories() {
        groups.forEach(group => {
            group.style.display = "";
            group.querySelectorAll('li').forEach(li => li.style.display = "");
        });
        // Reset buttons to "All"
        filterButtons.forEach(btn => btn.classList.remove('active'));
        document.querySelector('.btn-all').classList.add('active');
    }
    if (searchInput) {
      // Event: Typing in search
      searchInput.addEventListener('keyup', performSearch);
    }
    if (clearSearchBtn) {
      // Event: Clear Search Button
      clearSearchBtn.addEventListener('click', function() {
          searchInput.value = '';
          performSearch();
          searchInput.focus();
      });
    }

    if (filterButtons) {
    filterButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const targetFilter = this.getAttribute('data-filter');
            
            filterButtons.forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');

            groups.forEach(group => {
                const groupCategory = group.getAttribute('data-category');
                group.style.display = (targetFilter === 'all' || targetFilter === groupCategory) ? "" : "none";
                // Ensure items inside are visible
                group.querySelectorAll('li').forEach(li => li.style.display = "");
            });
        });
    });
    }
    /*Sticky observer*/
    /*document.addEventListener('DOMContentLoaded', function() {
        const header = document.querySelector('.sticky-observer');
        const sentinel = document.querySelector('#sticky-sentinel');

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    header.classList.add('is-sticky');
                } else {
                    header.classList.remove('is-sticky');
                }
            });
        }, {
            threshold: [0]
        });

        observer.observe(sentinel);
    });    */

    /*Tiny slider Highlight*/
    const tnsSliderHighlight = document.querySelectorAll('.-hg-tns');
    tnsSliderHighlight.forEach(SliderHighlight => {
      const tnsSliderHighlight = tns({
          container: SliderHighlight,
          items: 1,
          nav: true,
          controls: false,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          autoplay: false,
          autoplayTimeout: 3000,
          gutter: 0,
          loop: true,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          responsive: { 
              1366: {
               items: 1,
              },
              768: {
                items: 1,
              },
              320: {
                items: 1,
              }, 
          } 
      });
    });    

    /*Tiny slider services*/
    const tnsSliderGrid = document.querySelectorAll('.-services-tns');
    tnsSliderGrid.forEach(SliderGrid => {
      const tnsSliderGrid = tns({
          rewind: true,
          container: SliderGrid,
          items: 3,
          nav: false,
          controls: true,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          autoplay: false,
          autoplayTimeout: 3000,
          gutter: 24,
          loop: false,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:chevron-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:chevron-right"></iconify-icon></span>'],
          responsive: { 
              1920: {
                items: 2,
                //autoplay: true,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              1366: {
                items: 2.8,
                //autoplay: true,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 1.8,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                //autoplay: true,
                //nav: true,
                //gutter: 0
                /*loop: true,
                */
                /*gutter: 0,*/
              }, 
          } 
      });
      // Reference the bar
      const progressBar = document.getElementById('progress-bar');

      // Function to update the bar
      function updateProgressBar(info) {
        // Total items (5) minus items shown (3) + 1 = The last possible "step" (3)
        const maxStep = info.slideCount - info.items + 1;

        // Calculate percentage based on the current step relative to the max step
        // We use Math.min to ensure it never exceeds 100%
        const percentage = Math.min((info.displayIndex / maxStep) * 100, 100);

        progressBar.style.width = percentage + "%";
      }

      // 1. Run once on initialization
      updateProgressBar(tnsSliderGrid.getInfo());

      // 2. Listen for every slide change
      tnsSliderGrid.events.on('indexChanged', function(info) {
        updateProgressBar(info);
      });
    });    

    /*Tiny slider testimonials*/
    const tnsSliderTestimonials = document.querySelectorAll('.-testimonials-tns');
    tnsSliderTestimonials.forEach(SliderTestimonials => {
    /*const tnsTestimonials = document.querySelector('.-testimonials-tns');*/
      const tnsSliderTestimonials = tns({
          container: SliderTestimonials,
          items: 3,
          slideBy: 'page',
          autoplay: true,
          controlsContainer: "#custom-testimonials-controls",
          //navContainer: "#custom-testimonials-nav",
          nav: true,
          controls: true,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          
          
          autoplayTimeout: 4000,
          gutter: 32,
          loop: false,
          rewind: true,
          mouseDrag: true,
          controlsPosition: "bottom",
          navPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          responsive: { 
              1366: {
                items: 3,
                autoplay: false
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 2,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                autoplay: true
                //nav: true,
                //gutter: 0
                /*loop: true,
                */
                /*gutter: 0,*/
              }, 
          } 
      });

      var generatedNav = tnsSliderTestimonials.getInfo().navContainer;

      
      var placeholder = document.querySelector('#custom-testimonials-nav');

      
      placeholder.appendChild(generatedNav);
    });


    /*Tiny slider Brands*/
    const tnsSliderBrands = document.querySelectorAll('.-brands-tns');
    tnsSliderBrands.forEach(SliderBrands => {
      const tnsSliderBrands = tns({
          container: SliderBrands,
          items: 4,
          nav: false,
          controls: false,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplayTimeout: 3000,
          gutter: 16,
          loop: true,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          responsive: { 
              1366: {
               items: 4,
              },
              768: {
                items: 4,
              },
              320: {
                items: 2,
              }, 
          } 
      });
    });

    

    /*Tiny slider sponsor*/
    const tnsSingle = document.querySelector('.-single-tns');
    if (tnsSingle) {
      const tnsSlider = tns({
        container: tnsSingle,
        autoheight: false,
        items: 1,
        /*mouseDrag: true,*/
        autoplayButtonOutput: false,
        autoplay: false,
        loop: true,
        swipeAngle: false,
        navContainer: '.-single-tns-thumbs',
        navAsThumbnails: true,
        controlsText: ['<span class="-prev"><span class="iconify" data-icon="iconoir:arrow-left"></span></span>', '<span class="-next"><span class="iconify" data-icon="iconoir:arrow-right"></span></span>'],
  
        /*responsive: {     
          320: {
          },
          768: {
          },
          900: {
          }
        }*/


      });
      //tnsSlider.updateSliderHeight(); 
      var customizedFunction = function (info, eventName) {
        //tnsSlider.updateSliderHeight();
        //console.log(info);
        var indexCurrent = info.displayIndex;
        console.log(indexCurrent);
        var nextHeight = info.slideItems[indexCurrent].childNodes[1].clientHeight;
        /*console.log(nextHeight)*/
        info.container.offsetParent.childNodes[2].setAttribute('style', 'height:'+ nextHeight + 'px;');
      }
      tnsSlider.events.on('transitionEnd', customizedFunction);
      /*tnsSlider.events.on('indexChanged', customizedFunction);*/
    
    }
    const tnsSingleThumbs = document.querySelector('.-single-tns-thumbs');
    if (tnsSingleThumbs) {
      const tnsSlider = tns({
        container: tnsSingleThumbs,
        items: 6,
        mouseDrag: true,
        nav: false,
        controls: false,
        autoplayButtonOutput: false,
        gutter: 10,
        autoplay: false,
        controlsPosition: "bottom",
        loop: true,
        autoHeight: true,
  
        /*responsive: {     
          320: {
          },
          768: {
          },
          900: {
          }
        }*/

      });   
    
    }

/*form file*/
const formFileField = document.querySelectorAll('.custom-file-field');
const formFileFieldClear = document.getElementById('file-clear');
if (formFileField) {

  formFileField.forEach(fileField => {
      fileField.addEventListener('change', function() {
        var fileName = fileField.files[0] ? fileField.files[0].name : "Nenhum arquivo...";
        document.getElementById('file-upload-label').classList.add('hide')
        document.getElementById('file-info').classList.remove('hide')
        document.getElementById('file-info').classList.add('selected')
        document.getElementById('file-name-display').textContent = fileName;
        if (fileField.files[0]) {
            var file = fileField.files[0];
            var fileSize = formatBytes(file.size);
            document.getElementById('file-size-display').textContent = fileSize;
        }

      });
  });
}
if (formFileFieldClear) {
  formFileFieldClear.addEventListener('click', function() {
    console.log('clear trrigg')
      const groupFieldFile = this.closest('.-form-file-upload');
      const fileInput = groupFieldFile.querySelector('.custom-file-field');
      /*const nameDisplay = document.getElementById('nome-do-arquivo');
      const btnLimpar = document.getElementById('btn-limpar');*/

      fileInput.value = ""; // Limpa o arquivo no input real
      document.getElementById('file-upload-label').classList.remove('hide')
      document.getElementById('file-info').classList.add('hide')
      document.getElementById('file-info').classList.remove('selected')
  });
}


function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/*form trigger*/
const triggerFormSelect = document.querySelectorAll('.form-trigger');
const selectField = document.getElementById('type-select-dropdown');

if (triggerFormSelect) {

  triggerFormSelect.forEach(button => {
      button.addEventListener('click', function() {
          triggerFormSelect.forEach(btn => btn.classList.remove('active'));
          this.classList.add('active');
          const scrollTarget = this.getAttribute('data-scroll'); 

          if (selectField) {
              const val = this.getAttribute('data-value');
              selectField.value = val;
              selectField.dispatchEvent(new Event('change'));
          }
          if (scrollTarget) {
            const offsetTop = document.querySelector(scrollTarget).offsetTop;
            scroll({
              top: offsetTop,
              behavior: "smooth"
            });
          }
      });
  });
}



    /*Input Masks*/
    function runmask() {
      v_obj.value=v_fun(v_obj.value);
    }

    function mask(o,f) {
      v_obj=o;
      v_fun=f;
      setTimeout(runmask(),1)
    }

    function mtel(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
      v = v.replace(/(\d)(\d{4})$/, "$1-$2");
      return v;
    }

    function modate(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/g, "$1/$2");
      v = v.replace(/(\d)(\d{3})$/, "$1/$2");
      return v;
    }

    function mnumbers(v) {
      v = v.replace(/\D/g, "");
      return v;
    }
    function mcep(v) {
      v = v.replace(/\D/g, "");
      v = v.replace(/^(\d{5})(\d)/g, "$1-$2");
      return v;
    }
    function price(v) {
        /*v = v.replace(/\D/g, "");
        v = v.replace(/([0-9]{2})$/g, ",$1");
        v = v.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
        v = v.replace(/([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, ".$1.$2,$3");
        v = v.replace(/([0-9]{3}).([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, ".$1.$2.$3,$4");
        return v;*/
        v = v + '';
        v = parseInt(v.replace(/[\D]+/g, ''));
        v = v + '';
        v = v.replace(/([0-9]{2})$/g, ",$1");

        if (v.length > 6) {
            v = v.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
        }

        if(v == 'NaN') v = '';
        return v;
    }

    function mCpf(v){
      //Remove tudo o que não é dígito
      v=v.replace(/\D/g,"")

      //Coloca um ponto entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{3})(\d)/,"$1.$2")

      //Coloca um ponto entre o terceiro e o quarto dígitos
      //de novo (para o segundo bloco de números)
      v=v.replace(/(\d{3})(\d)/,"$1.$2")

      //Coloca um hífen entre o terceiro e o quarto dígitos
      v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2")

      return v  
    }

    function cpfCnpj(v){
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g,"");
     
        if (v.length < 14) { //CPF   405.604.628-08  43.201.151/0001-99
     
            //Coloca um ponto entre o terceiro e o quarto dígitos
            v=v.replace(/(\d{3})(\d)/,"$1.$2")
     
            //Coloca um ponto entre o terceiro e o quarto dígitos
            //de novo (para o segundo bloco de números)
            v=v.replace(/(\d{3})(\d)/,"$1.$2")
     
            //Coloca um hífen entre o terceiro e o quarto dígitos
            v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
     
        } else { //CNPJ
            //console.log('aki');
            //Coloca ponto entre o segundo e o terceiro dígitos
            v=v.replace(/^(\d{2})(\d)/,"$1.$2")
     
            //Coloca ponto entre o quinto e o sexto dígitos
            v=v.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3")
     
            //Coloca uma barra entre o oitavo e o nono dígitos
            v=v.replace(/\.(\d{3})(\d)/,".$1/$2")
     
            //Coloca um hífen depois do bloco de quatro dígitos
            v=v.replace(/(\d{4})(\d)/,"$1-$2")
     
        }
     
        return v
     
    }

    var cepValidator = document.getElementsByClassName('mask-cep');
    var cpfValidator = document.getElementsByClassName('mask-cpf');
    var telValidator = document.getElementsByClassName('mask-tel');
    var dateValidator = document.getElementsByClassName('mask-date');
    var priceValidator = document.getElementsByClassName('mask-price');
    var documentValidator = document.getElementsByClassName('mask-doc');
    var numberValidator = document.getElementsByClassName('mask-num');
   

    if(cepValidator && cepValidator.length != -1){
      for (i = 0; i < cepValidator.length; i++) {
        cepValidator[i].addEventListener('keydown', function() {
          mask(this, mcep);
        });
      }
    }
    if(cpfValidator && cpfValidator.length != -1){
      for (i = 0; i < cpfValidator.length; i++) {
        cpfValidator[i].addEventListener('keydown', function() {
          mask(this, mCpf);
        });
      }
    }
    if(telValidator && telValidator.length != -1){
      for (i = 0; i < telValidator.length; i++) {
        telValidator[i].addEventListener('keydown', function() {
          mask(this, mtel);
        });
      }
    }
    if(dateValidator && dateValidator.length != -1){
      for (i = 0; i < dateValidator.length; i++) {
        dateValidator[i].addEventListener('keydown', function() {
          mask(this, modate);
        });
      }
    }
    if(numberValidator && numberValidator.length != -1){
      for (i = 0; i < numberValidator.length; i++) {
        numberValidator[i].addEventListener('keydown', function() {
          mask(this, mnumbers);
        });
      }
    }

    if(priceValidator && priceValidator.length != -1){
      for (i = 0; i < priceValidator.length; i++) {
        priceValidator[i].addEventListener('keyup', function() {
          mask(this, price);
        });
      }
    }

    if(documentValidator && documentValidator.length != -1){
      for (i = 0; i < documentValidator.length; i++) {
        documentValidator[i].addEventListener('keydown', function() {
          mask(this, cpfCnpj);
        });
      }
    }

    /*CEP autocomplete*/
    $(".cep-autocomplete").blur(function(){
        var address = $(this).closest('form').find(".endereco");
        var number = $(this).closest('form').find(".numero");
        var neighborhood = $(this).closest('form').find(".bairro");
        var city = $(this).closest('form').find(".cidade");
        var state = $(this).closest('form').find(".estado");
        var cep = this.value.replace(/[^0-9]/, "");
        if(cep.length != 8){
            return false;
        }        
        var url = "https://viacep.com.br/ws/"+cep+"/json/";
        $.getJSON(url, function(dadosRetorno){ /*console.log(dadosRetorno);*/
            try{
                address.val(dadosRetorno.logradouro);
                neighborhood.val(dadosRetorno.bairro);
                city.val(dadosRetorno.localidade);
                state.val(dadosRetorno.uf);
                number.focus();
            }catch(ex){}
        });
    });                

     /*GDPR*/
    document.addEventListener('DOMContentLoaded', function() {
      var cookiebar = document.querySelector('.cookiebar');
      if (cookiebar) { 
          var closecookiebar = document.querySelector('.hide-cookiebar-target');
          var acceptcookie = document.querySelector('.accept-cookies');
          var refusecookie = document.querySelector('.refuse-cookies');
          var cookie = readCookie('portaldalongevidade_cookie_lgpd_consent');/*Name of cookie*/
          //console.log(cookie);

          if (cookie == "true") {
              cookiebar.style.display = "none";
          }else if (cookie == "false") {
              cookiebar.style.display = "none";
          }else{
              cookiebar.classList.add("no-cookie-yet");
          }

          acceptcookie.addEventListener('click', function(e) {
              if(cookie != "true") {
                cookiebar.style.display = "none";
                createCookie('portaldalongevidade_cookie_lgpd_consent', "true", 7);
              } 
              e.preventDefault();
          });

          if (refusecookie) {
            refusecookie.addEventListener('click', function(e) {
                if(cookie != "true") {
                  cookiebar.style.display = "none";
                  createCookie('portaldalongevidade_cookie_lgpd_consent', "false", 7);
                }
                e.preventDefault();
            });  
          }
          
          if (closecookiebar) {
            closecookiebar.addEventListener('click', function(e) {
                cookiebar.style.display = "none";
                /*if(cookie != "true") {
                  createCookie('portaldalongevidade_cookie_lgpd_consent', "true", 1);
                } */
                e.preventDefault();
            });
          }

      }

      function createCookie(name, value, days) {
          if(days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
          } else var expires = "";
          document.cookie = name + "=" + value + expires + "; path=/"
      }

      function readCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
           
          }
          return null;
      }

      function eraseCookie(name) {
          createCookie(name, "", -1);
      }

    });

    /*Scroller slider*/
    const iScrollers = document.querySelectorAll(".i-scroll");

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      addAnimation();
    }

    function addAnimation() {
      iScrollers.forEach((iScroller) => {
        iScroller.setAttribute("data-animated", true);

        const iScrollerInner = iScroller.querySelector(".i-scroll__inner");
        const iScrollerContent = Array.from(iScrollerInner.children);

        iScrollerContent.forEach((item) => {
          const duplicatedItem = item.cloneNode(true);
          duplicatedItem.setAttribute("aria-hidden", true);
          iScrollerInner.appendChild(duplicatedItem);
        });
      });
    }          

    if(document.querySelector('.hero-video-wrap')){
      (function() {
        const wrap = document.querySelector('.hero-video-wrap');
        const playBtn = document.querySelector('.hero-video-play');
        const youtubeVideo = document.getElementById('heroVideoYoutube');
        const video = document.getElementById('heroVideo');
        let player;
        let isPlayerReady = false; // Flag para evitar o erro

        if (youtubeVideo) {
          // 1. Carrega a API do YouTube
          const tag = document.createElement('script');
          tag.src = "https://www.youtube.com/iframe_api";
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          // 2. Inicializa o Player
          window.onYouTubeIframeAPIReady = function() {
            player = new YT.Player('heroVideoYoutube', {
              videoId: 'R73nl9vDVk0',
              playerVars: {
                'autoplay': 0,
                'mute': 1,
                'controls': 0,
                'rel': 0,
                'showinfo': 0,
                'modestbranding': 1
              },
              events: {
                'onReady': () => { isPlayerReady = true; }, // Ativa a flag quando estiver pronto
                'onStateChange': onPlayerStateChange
              }
            });
          };

          // 3. Clique do Botão (Com proteção contra o erro)
          playBtn.addEventListener('click', () => {
            // Só executa se o player existir E os métodos estiverem disponíveis
            if (player && isPlayerReady && typeof player.getPlayerState === 'function') {
              const state = player.getPlayerState();

              if (state !== YT.PlayerState.PLAYING) {
                player.playVideo();
                player.unMute();
                wrap.classList.add('is-playing');
              } else {
                player.pauseVideo();
                wrap.classList.remove('is-playing');
              }
            } else {
              console.log("O player ainda está carregando...");
            }
          });

          function onPlayerStateChange(event) {
            if (event.data === YT.PlayerState.ENDED) {
              wrap.classList.remove('is-playing');
              player.seekTo(0);
              player.pauseVideo(); 
            }
          }
        }else{
          // Start muted to allow autoplay on some devices after first tap
          video.muted = true;

          playBtn.addEventListener('click', async () => {
            if (video.paused) {
              await video.play();
              wrap.classList.add('is-playing');
              video.muted = false;
            } else {
              video.pause();
              wrap.classList.remove('is-playing');
              video.muted = true;
            }
          });

          // If the video ends and you want it to loop:
          video.addEventListener('ended', () => {
            video.currentTime = 0;
            wrap.classList.remove('is-playing');
            /*video.play();*/
          });
        }
      })();   
    }             

    var header = document.querySelectorAll(".dynamic-header");
    if (!header.length) { return; }
    var headerHeight = header[0].offsetHeight;
    window.onscroll = function() {
      //console.log(window.innerWidth)
        var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        var vh1o3 = (window.innerWidth/3);
        var vh1o2 = (window.innerWidth/2);
        var vhMin = 100;
        var vhMinWA = 200;
        /*if (scrollPosition > headerHeight && window.innerWidth > 992) {*/
        /*if (scrollPosition > headerHeight) {*/
        if (scrollPosition > vhMin) {
                header[0].classList.add('-sticky');
                
        }else{
                header[0].classList.remove('-sticky');
                
        }

        if (scrollPosition > vhMinWA) {
                
                document.body.classList.add("-has-sticky");
        }else{
                
                document.body.classList.remove("-has-sticky");
        }
    }; 

   

}(window.jQuery, window, document));